import { propsToClasses } from '../utils';
var styles = {
  "boxSizing-border": "Box-boxSizing-border__V1q3",
  "boxSizing-content": "Box-boxSizing-content_1n5Lw",
  "margin-none": "Box-margin-none_1M7R9",
  "marginTop-none": "Box-marginTop-none_1ZHLN",
  "marginRight-none": "Box-marginRight-none_3zggS",
  "marginBottom-none": "Box-marginBottom-none_c_Tb8",
  "marginLeft-none": "Box-marginLeft-none_3tHxv",
  "marginX-none": "Box-marginX-none_3jM16 Box-marginRight-none_3zggS Box-marginLeft-none_3tHxv",
  "marginY-none": "Box-marginY-none_2P_F7 Box-marginTop-none_1ZHLN Box-marginBottom-none_c_Tb8",
  "padding-none": "Box-padding-none_3tJVQ",
  "paddingTop-none": "Box-paddingTop-none_1bTkO",
  "paddingRight-none": "Box-paddingRight-none_3Qs5-",
  "paddingBottom-none": "Box-paddingBottom-none_2f5Z7",
  "paddingLeft-none": "Box-paddingLeft-none_2oziS",
  "paddingX-none": "Box-paddingX-none_2STFM Box-paddingRight-none_3Qs5- Box-paddingLeft-none_2oziS",
  "paddingY-none": "Box-paddingY-none_1KseO Box-paddingTop-none_1bTkO Box-paddingBottom-none_2f5Z7",
  "border-none": "Box-border-none_2aFKN",
  "margin-xxsmall": "Box-margin-xxsmall_2-qFo",
  "margin-xsmall": "Box-margin-xsmall_1pMFm",
  "margin-small": "Box-margin-small_2mvQR",
  "margin-base": "Box-margin-base_2MWBr",
  "margin-medium": "Box-margin-medium_3MoRA",
  "margin-large": "Box-margin-large_3r2db",
  "marginTop-xxsmall": "Box-marginTop-xxsmall_12WTE",
  "marginTop-xsmall": "Box-marginTop-xsmall_3tKct",
  "marginTop-small": "Box-marginTop-small_37oYP",
  "marginTop-base": "Box-marginTop-base_3pYGI",
  "marginTop-medium": "Box-marginTop-medium_rxfew",
  "marginTop-large": "Box-marginTop-large_3D_jh",
  "marginRight-xxsmall": "Box-marginRight-xxsmall_3hPQb",
  "marginRight-xsmall": "Box-marginRight-xsmall_3Te9A",
  "marginRight-small": "Box-marginRight-small_1_IGL",
  "marginRight-base": "Box-marginRight-base_3sLSP",
  "marginRight-medium": "Box-marginRight-medium_2_wmC",
  "marginRight-large": "Box-marginRight-large_2bi4b",
  "marginBottom-xxsmall": "Box-marginBottom-xxsmall_1j-x5",
  "marginBottom-xsmall": "Box-marginBottom-xsmall_3T43M",
  "marginBottom-small": "Box-marginBottom-small_36hSl",
  "marginBottom-base": "Box-marginBottom-base_3BtuF",
  "marginBottom-medium": "Box-marginBottom-medium_26JSb",
  "marginBottom-large": "Box-marginBottom-large_3p-Z2",
  "marginLeft-xxsmall": "Box-marginLeft-xxsmall_3-l0K",
  "marginLeft-xsmall": "Box-marginLeft-xsmall_3YG5F",
  "marginLeft-small": "Box-marginLeft-small_ebD6T",
  "marginLeft-base": "Box-marginLeft-base_bnBP6",
  "marginLeft-medium": "Box-marginLeft-medium_3p2eA",
  "marginLeft-large": "Box-marginLeft-large_3kJsx",
  "padding-xxsmall": "Box-padding-xxsmall_eQHyM",
  "padding-xsmall": "Box-padding-xsmall_1rmUp",
  "padding-small": "Box-padding-small_V2bt1",
  "padding-base": "Box-padding-base_2NPh_",
  "padding-medium": "Box-padding-medium_2UHCU",
  "padding-large": "Box-padding-large_12lAc",
  "paddingTop-xxsmall": "Box-paddingTop-xxsmall_6QYgb",
  "paddingTop-xsmall": "Box-paddingTop-xsmall_22Udt",
  "paddingTop-small": "Box-paddingTop-small_3khBc",
  "paddingTop-base": "Box-paddingTop-base_c3dWz",
  "paddingTop-medium": "Box-paddingTop-medium_3SG8T",
  "paddingTop-large": "Box-paddingTop-large_39SBW",
  "paddingRight-xxsmall": "Box-paddingRight-xxsmall_2n_QQ",
  "paddingRight-xsmall": "Box-paddingRight-xsmall_lFmuO",
  "paddingRight-small": "Box-paddingRight-small_Mw0L5",
  "paddingRight-base": "Box-paddingRight-base_1haxy",
  "paddingRight-medium": "Box-paddingRight-medium_39EzN",
  "paddingRight-large": "Box-paddingRight-large_1PXa3",
  "paddingBottom-xxsmall": "Box-paddingBottom-xxsmall_3UQT2",
  "paddingBottom-xsmall": "Box-paddingBottom-xsmall_15dmU",
  "paddingBottom-small": "Box-paddingBottom-small_8H12T",
  "paddingBottom-base": "Box-paddingBottom-base_3jGv5",
  "paddingBottom-medium": "Box-paddingBottom-medium_2T-QD",
  "paddingBottom-large": "Box-paddingBottom-large_1HuJc",
  "paddingLeft-xxsmall": "Box-paddingLeft-xxsmall_21778",
  "paddingLeft-xsmall": "Box-paddingLeft-xsmall_2EBus",
  "paddingLeft-small": "Box-paddingLeft-small_1mVBq",
  "paddingLeft-base": "Box-paddingLeft-base_3TvKD",
  "paddingLeft-medium": "Box-paddingLeft-medium_33M6y",
  "paddingLeft-large": "Box-paddingLeft-large_1pbV4",
  "marginX-xxsmall": "Box-marginX-xxsmall_18DvK Box-marginLeft-xxsmall_3-l0K Box-marginRight-xxsmall_3hPQb",
  "marginX-xsmall": "Box-marginX-xsmall_1QW2S Box-marginLeft-xsmall_3YG5F Box-marginRight-xsmall_3Te9A",
  "marginX-small": "Box-marginX-small_3BysS Box-marginLeft-small_ebD6T Box-marginRight-small_1_IGL",
  "marginX-base": "Box-marginX-base_iQ5IQ Box-marginLeft-base_bnBP6 Box-marginRight-base_3sLSP",
  "marginX-medium": "Box-marginX-medium_1bZ99 Box-marginLeft-medium_3p2eA Box-marginRight-medium_2_wmC",
  "marginX-large": "Box-marginX-large_y_1bX Box-marginLeft-large_3kJsx Box-marginRight-large_2bi4b",
  "marginY-xxsmall": "Box-marginY-xxsmall_2QzlJ Box-marginTop-xxsmall_12WTE Box-marginBottom-xxsmall_1j-x5",
  "marginY-xsmall": "Box-marginY-xsmall_2hry8 Box-marginTop-xsmall_3tKct Box-marginBottom-xsmall_3T43M",
  "marginY-small": "Box-marginY-small_iwOKP Box-marginTop-small_37oYP Box-marginBottom-small_36hSl",
  "marginY-base": "Box-marginY-base_2h3Li Box-marginTop-base_3pYGI Box-marginBottom-base_3BtuF",
  "marginY-medium": "Box-marginY-medium_zgBiD Box-marginTop-medium_rxfew Box-marginBottom-medium_26JSb",
  "marginY-large": "Box-marginY-large_2vhAx Box-marginTop-large_3D_jh Box-marginBottom-large_3p-Z2",
  "paddingX-xxsmall": "Box-paddingX-xxsmall_3V7Qi Box-paddingLeft-xxsmall_21778 Box-paddingRight-xxsmall_2n_QQ",
  "paddingX-xsmall": "Box-paddingX-xsmall_14Ki_ Box-paddingLeft-xsmall_2EBus Box-paddingRight-xsmall_lFmuO",
  "paddingX-small": "Box-paddingX-small_2LJQE Box-paddingLeft-small_1mVBq Box-paddingRight-small_Mw0L5",
  "paddingX-base": "Box-paddingX-base_2eHRz Box-paddingLeft-base_3TvKD Box-paddingRight-base_1haxy",
  "paddingX-medium": "Box-paddingX-medium_1f-TG Box-paddingLeft-medium_33M6y Box-paddingRight-medium_39EzN",
  "paddingX-large": "Box-paddingX-large_1jWqH Box-paddingLeft-large_1pbV4 Box-paddingRight-large_1PXa3",
  "paddingY-xxsmall": "Box-paddingY-xxsmall_Vp2ap Box-paddingTop-xxsmall_6QYgb Box-paddingBottom-xxsmall_3UQT2",
  "paddingY-xsmall": "Box-paddingY-xsmall_34kFF Box-paddingTop-xsmall_22Udt Box-paddingBottom-xsmall_15dmU",
  "paddingY-small": "Box-paddingY-small_31T-T Box-paddingTop-small_3khBc Box-paddingBottom-small_8H12T",
  "paddingY-base": "Box-paddingY-base_16nUO Box-paddingTop-base_c3dWz Box-paddingBottom-base_3jGv5",
  "paddingY-medium": "Box-paddingY-medium_1JgDS Box-paddingTop-medium_3SG8T Box-paddingBottom-medium_2T-QD",
  "paddingY-large": "Box-paddingY-large_3M4lk Box-paddingTop-large_39SBW Box-paddingBottom-large_1HuJc",
  "position-static": "Box-position-static_1NBBf",
  "position-relative": "Box-position-relative_2ZIyf",
  "position-absolute": "Box-position-absolute_1PFAg",
  "position-fixed": "Box-position-fixed_1z0DG",
  "visibility-visible": "Box-visibility-visible_1ZCKL",
  "visibility-hidden": "Box-visibility-hidden_1E-tU",
  "backgroundColor-surface": "Box-backgroundColor-surface_16hjy",
  "backgroundColor-background": "Box-backgroundColor-background_A2tO5",
  "backgroundColor-neutral-weak": "Box-backgroundColor-neutral-weak_15so8",
  "backgroundColor-neutral-plain": "Box-backgroundColor-neutral-plain_3jNwE",
  "backgroundColor-neutral-strong": "Box-backgroundColor-neutral-strong_MEHSl",
  "backgroundColor-white": "Box-backgroundColor-white_3LQ-e",
  "backgroundColor-green": "Box-backgroundColor-green_1kviD",
  "backgroundColor-green-dark": "Box-backgroundColor-green-dark_3An_C",
  "backgroundColor-green-darker": "Box-backgroundColor-green-darker_2EUrX",
  "backgroundColor-blue": "Box-backgroundColor-blue_2PS2q",
  "backgroundColor-blue-dark": "Box-backgroundColor-blue-dark_3jt4E",
  "backgroundColor-blue-darker": "Box-backgroundColor-blue-darker_1wtZ1",
  "backgroundColor-grey-lighter": "Box-backgroundColor-grey-lighter_1VcXS",
  "backgroundColor-grey-light": "Box-backgroundColor-grey-light_1OYyv",
  "backgroundColor-grey": "Box-backgroundColor-grey_2JAfv",
  "backgroundColor-grey-dark": "Box-backgroundColor-grey-dark_35wOl",
  "backgroundColor-grey-darker": "Box-backgroundColor-grey-darker_1FO91",
  "backgroundColor-anthracite": "Box-backgroundColor-anthracite_3trec",
  "backgroundColor-red": "Box-backgroundColor-red_3V_Is",
  "backgroundColor-red-dark": "Box-backgroundColor-red-dark_3n5gr",
  "backgroundColor-info": "Box-backgroundColor-info_1rZOa",
  "backgroundColor-success": "Box-backgroundColor-success_1aIt0",
  "backgroundColor-warning": "Box-backgroundColor-warning_206Q5",
  "backgroundColor-danger": "Box-backgroundColor-danger_ig29p",
  "backgroundColor-promotional": "Box-backgroundColor-promotional_26u_S",
  "backgroundColor-transparent": "Box-backgroundColor-transparent_3WlDE",
  "hoverBackgroundColor-white": "Box-hoverBackgroundColor-white_3gaRE",
  "hoverBackgroundColor-green": "Box-hoverBackgroundColor-green_34s1_",
  "hoverBackgroundColor-green-dark": "Box-hoverBackgroundColor-green-dark_27EoG",
  "hoverBackgroundColor-green-darker": "Box-hoverBackgroundColor-green-darker_28Myl",
  "hoverBackgroundColor-blue": "Box-hoverBackgroundColor-blue_1E5Ys",
  "hoverBackgroundColor-blue-dark": "Box-hoverBackgroundColor-blue-dark_37VC1",
  "hoverBackgroundColor-blue-darker": "Box-hoverBackgroundColor-blue-darker_3qX1F",
  "hoverBackgroundColor-grey-lighter": "Box-hoverBackgroundColor-grey-lighter_3C6xe",
  "hoverBackgroundColor-grey-light": "Box-hoverBackgroundColor-grey-light_1T_Jl",
  "hoverBackgroundColor-grey": "Box-hoverBackgroundColor-grey_3x_jJ",
  "hoverBackgroundColor-grey-dark": "Box-hoverBackgroundColor-grey-dark_3pSyU",
  "hoverBackgroundColor-grey-darker": "Box-hoverBackgroundColor-grey-darker_j2r1S",
  "hoverBackgroundColor-success": "Box-hoverBackgroundColor-success_2l8gK",
  "hoverBackgroundColor-success-dark": "Box-hoverBackgroundColor-success-dark_25Hh6",
  "hoverBackgroundColor-red": "Box-hoverBackgroundColor-red_1yMd4",
  "hoverBackgroundColor-red-dark": "Box-hoverBackgroundColor-red-dark_kig6L",
  "hoverBackgroundColor-promotional": "Box-hoverBackgroundColor-promotional_hT_W4",
  "hoverBackgroundColor-promotional-dark": "Box-hoverBackgroundColor-promotional-dark_1Usr8",
  "borderColor-weak": "Box-borderColor-weak_34vjf",
  "borderColor-base": "Box-borderColor-base_38tCS",
  "borderColor-strong": "Box-borderColor-strong_3MOpy",
  "borderColor-white": "Box-borderColor-white_1-lO3",
  "borderColor-green": "Box-borderColor-green_cuLCi",
  "borderColor-green-dark": "Box-borderColor-green-dark_380e9",
  "borderColor-green-darker": "Box-borderColor-green-darker_1_BBe",
  "borderColor-blue": "Box-borderColor-blue_28uxe",
  "borderColor-blue-dark": "Box-borderColor-blue-dark_hp7JR",
  "borderColor-blue-darker": "Box-borderColor-blue-darker__2GOo",
  "borderColor-red": "Box-borderColor-red_29eZ7",
  "borderColor-red-dark": "Box-borderColor-red-dark_2ztNx",
  "borderColor-red-darker": "Box-borderColor-red-darker_2Wbqw",
  "borderColor-info": "Box-borderColor-info_27Q2q",
  "borderColor-success": "Box-borderColor-success_3oO3o",
  "borderColor-warning": "Box-borderColor-warning_mmNHd",
  "borderColor-danger": "Box-borderColor-danger_1U1N2",
  "borderColor-grey-lighter": "Box-borderColor-grey-lighter_yPo-E",
  "borderColor-grey-light": "Box-borderColor-grey-light_JDoJw",
  "borderColor-grey": "Box-borderColor-grey_1sG0g",
  "borderColor-grey-dark": "Box-borderColor-grey-dark_1oDFI",
  "borderColor-grey-darker": "Box-borderColor-grey-darker_2EeNT",
  "borderColor-anthracite": "Box-borderColor-anthracite_34TEb",
  "borderColor-text-light": "Box-borderColor-text-light_zT-YT",
  "borderColor-transparent": "Box-borderColor-transparent_1bSeO",
  "hoverBorderColor-white": "Box-hoverBorderColor-white_1dbuS",
  "hoverBorderColor-green": "Box-hoverBorderColor-green_Tlr1u",
  "hoverBorderColor-green-dark": "Box-hoverBorderColor-green-dark_38LdL",
  "hoverBorderColor-green-darker": "Box-hoverBorderColor-green-darker_gYU4i",
  "hoverBorderColor-blue": "Box-hoverBorderColor-blue_1Igbc",
  "hoverBorderColor-blue-dark": "Box-hoverBorderColor-blue-dark_3U8yq",
  "hoverBorderColor-blue-darker": "Box-hoverBorderColor-blue-darker_1pID4",
  "hoverBorderColor-red": "Box-hoverBorderColor-red_2VHqb",
  "hoverBorderColor-red-dark": "Box-hoverBorderColor-red-dark_26-QV",
  "hoverBorderColor-red-darker": "Box-hoverBorderColor-red-darker_-f92K",
  "hoverBorderColor-info": "Box-hoverBorderColor-info_2pI_I",
  "hoverBorderColor-success": "Box-hoverBorderColor-success_BtcrX",
  "hoverBorderColor-warning": "Box-hoverBorderColor-warning_3ATBE",
  "hoverBorderColor-danger": "Box-hoverBorderColor-danger_krl_m",
  "hoverBorderColor-grey": "Box-hoverBorderColor-grey_25wTV",
  "hoverBorderColor-grey-dark": "Box-hoverBorderColor-grey-dark_jnH9k",
  "hoverBorderColor-grey-darker": "Box-hoverBorderColor-grey-darker_2o87c",
  "hoverBorderColor-anthracite": "Box-hoverBorderColor-anthracite_Z0tNg",
  "hoverBorderColor-text-light": "Box-hoverBorderColor-text-light_1yrDY",
  "hoverBorderColor-transparent": "Box-hoverBorderColor-transparent_-Jbjk",
  "hoverable": "Box-hoverable_1FPu7",
  "interactive": "Box-interactive_ij9NR Box-hoverable_1FPu7",
  "separatorTop": "Box-separatorTop_2dQOt",
  "separatorRight": "Box-separatorRight_1ihc_",
  "separatorBottom": "Box-separatorBottom_2MYZH",
  "separatorLeft": "Box-separatorLeft_392r9",
  "bordered": "Box-bordered_ZIQTS",
  "borderedTop": "Box-borderedTop_368e5",
  "borderedRight": "Box-borderedRight_hDxqb",
  "borderedBottom": "Box-borderedBottom_14CqU",
  "borderedLeft": "Box-borderedLeft_1wwZi",
  "borderRadius-1x": "Box-borderRadius-1x_em5dW",
  "borderTopLeftRadius-1x": "Box-borderTopLeftRadius-1x_2vBSz",
  "borderTopRightRadius-1x": "Box-borderTopRightRadius-1x_1NUQ5",
  "borderBottomRightRadius-1x": "Box-borderBottomRightRadius-1x_2bOD2",
  "borderBottomLeftRadius-1x": "Box-borderBottomLeftRadius-1x_1hyz8",
  "borderStartRadius-1x": "Box-borderStartRadius-1x_sT2r-",
  "borderEndRadius-1x": "Box-borderEndRadius-1x_8ev9j",
  "borderRadius-2x": "Box-borderRadius-2x_3eCif",
  "borderTopLeftRadius-2x": "Box-borderTopLeftRadius-2x_2tDz6",
  "borderTopRightRadius-2x": "Box-borderTopRightRadius-2x_VhLPs",
  "borderBottomRightRadius-2x": "Box-borderBottomRightRadius-2x_ZPzVE",
  "borderBottomLeftRadius-2x": "Box-borderBottomLeftRadius-2x_208lo",
  "borderStartRadius-2x": "Box-borderStartRadius-2x_1vhXe",
  "borderEndRadius-2x": "Box-borderEndRadius-2x_13Bqx",
  "highlight-neutral-strong": "Box-highlight-neutral-strong_3dZgL",
  "highlight-brand": "Box-highlight-brand_1LrM3",
  "highlight-informative": "Box-highlight-informative_2gG_0",
  "highlight-positive": "Box-highlight-positive_wfEri",
  "highlight-notice": "Box-highlight-notice_opRa_",
  "highlight-negative": "Box-highlight-negative_wQzjy",
  "highlight-anthracite": "Box-highlight-anthracite_A84PV",
  "highlight-green": "Box-highlight-green_1eLYv",
  "highlight-info": "Box-highlight-info_2_JUq",
  "highlight-success": "Box-highlight-success_867k7",
  "highlight-warning": "Box-highlight-warning_62xK-",
  "highlight-danger": "Box-highlight-danger_3s-PM",
  "hoverHighlight-anthracite": "Box-hoverHighlight-anthracite_1nfi6",
  "hoverHighlight-green": "Box-hoverHighlight-green_17hEB",
  "grid": "Box-grid_35OHu",
  "gridInline": "Box-gridInline_21Xyz",
  "placeItemsCenter": "Box-placeItemsCenter_2i_nv",
  "gap-xxsmall": "Box-gap-xxsmall_1MrMP",
  "gap-xsmall": "Box-gap-xsmall_1_DKb",
  "gap-small": "Box-gap-small_3oDrW",
  "gap-base": "Box-gap-base_MTP6l",
  "gap-medium": "Box-gap-medium_38icT",
  "gap-large": "Box-gap-large_3fQf2",
  "columnGap-xxsmall": "Box-columnGap-xxsmall_2FNCp",
  "columnGap-xsmall": "Box-columnGap-xsmall_3J8Y0",
  "columnGap-small": "Box-columnGap-small_1wGAw",
  "columnGap-base": "Box-columnGap-base_3QfoK",
  "columnGap-medium": "Box-columnGap-medium_1vKs6",
  "columnGap-large": "Box-columnGap-large_lVFPl",
  "rowGap-xxsmall": "Box-rowGap-xxsmall_3OejP",
  "rowGap-xsmall": "Box-rowGap-xsmall_1iUM7",
  "rowGap-small": "Box-rowGap-small_3Zjwa",
  "rowGap-base": "Box-rowGap-base_Q3Dzg",
  "rowGap-medium": "Box-rowGap-medium_1fdeF",
  "rowGap-large": "Box-rowGap-large_3_1ZK",
  "gap-spacing-1x": "Box-gap-spacing-1x_3Arj7",
  "gap-spacing-2x": "Box-gap-spacing-2x_2hvKl",
  "gap-spacing-3x": "Box-gap-spacing-3x_H8wt3",
  "gap-spacing-4x": "Box-gap-spacing-4x_mE_pG",
  "gap-spacing-5x": "Box-gap-spacing-5x_3_Nng",
  "padding-spacing-4x": "Box-padding-spacing-4x_2hEDk",
  "paddingTop-spacing-4x": "Box-paddingTop-spacing-4x_1oVE2",
  "paddingRight-spacing-4x": "Box-paddingRight-spacing-4x_217jV",
  "paddingBottom-spacing-4x": "Box-paddingBottom-spacing-4x_3tq1y",
  "paddingLeft-spacing-4x": "Box-paddingLeft-spacing-4x_2pBCM"
};
export function Documentation(props) {}
export function useBox(props) {
  const {
    grid,
    gridInline,
    boxSizing,
    margin,
    padding,
    gap,
    columnGap,
    rowGap,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    marginX,
    marginY,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    paddingX,
    paddingY,
    placeItemsCenter,
    position,
    separatorTop,
    separatorRight,
    separatorBottom,
    separatorLeft,
    border,
    bordered,
    borderedTop,
    borderedRight,
    borderedBottom,
    borderedLeft,
    borderRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderBottomLeftRadius,
    borderStartRadius,
    borderEndRadius,
    visibility,
    backgroundColor,
    hoverBackgroundColor,
    borderColor,
    hoverBorderColor,
    highlight,
    hoverHighlight,
    hoverable,
    interactive,
    ...extraProps
  } = props;
  const classes = propsToClasses(props, styles);
  return [classes, extraProps];
}